var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2519 9.29505C14.2519 9.16174 14.2053 9.03394 14.1225 8.94005L10.8062 5.15005C10.7268 5.05338 10.616 4.99854 10.5 4.99854C10.3839 4.99854 10.2731 5.05338 10.1937 5.15005L6.87746 8.94005C6.79463 9.03394 6.74805 9.16174 6.74805 9.29505C6.74805 9.42837 6.79463 9.55617 6.87746 9.65005L7.05246 9.85005C7.13477 9.94771 7.24882 10.002 7.36746 10.0001H13.6325C13.7511 10.002 13.8651 9.94771 13.9475 9.85005L14.1225 9.65005C14.2053 9.55617 14.2519 9.42837 14.2519 9.29505ZM6.74805 14.7051C6.74805 14.8384 6.79463 14.9662 6.87746 15.0601L10.1937 18.8501C10.2731 18.9467 10.3839 19.0016 10.5 19.0016C10.616 19.0016 10.7268 18.9467 10.8062 18.8501L14.1225 15.0601C14.2053 14.9662 14.2519 14.8384 14.2519 14.7051C14.2519 14.5717 14.2053 14.4439 14.1225 14.3501L13.9475 14.1501C13.8651 14.0524 13.7511 13.9981 13.6325 14.0001H7.36746C7.24882 13.9981 7.13477 14.0524 7.05246 14.1501L6.87746 14.3501C6.79463 14.4439 6.74805 14.5717 6.74805 14.7051Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.34b9477b3f7a88f1c366767a3831cdba.svg";
export { ForwardRef as ReactComponent };